import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Divider from "@mui/material/Divider";
import debounce from "lodash/debounce";
import NumberInput from "../input/number-input";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import FixedSelectInput from "../input/fixed-select-input";
import SearchableSelectInput from "../input/searchable-select-input";
import NumberUnitInput from "../input/number-unit-input";
import Button from "@mui/material/Button";

const ToyCard = ({ toy, onUpdate, onDelete, onSendEvent }) => {
  const fieldMap = {
    FIXED_SELECT: f => (
      <FixedSelectInput
        useBiToggle={true}
        valueSpec={f}
        onChange={value => handleFieldChange(f, value)}
        onError={() => {}}
      ></FixedSelectInput>
    ),
    DYNAMIC_SELECT: f => (
      <SearchableSelectInput
        field={f}
        onChange={value => handleFieldChange(f, value)}
      ></SearchableSelectInput>
    ),
    NUMBER: f => (
      <NumberInput
        valueSpec={f}
        onChange={value => handleFieldChange(f, value)}
      ></NumberInput>
    ),
    NUMBER_UNIT: f => (
      <NumberUnitInput
        valueSpec={f}
        onChange={(value, unit, max, min) =>
          handleFieldChange(f, value, unit, max, min)
        }
      ></NumberUnitInput>
    ),
    BUTTON: (f, func) => (
      <Button variant="contained" onClick={() => handleFieldClick(func)}>
        {f.name}
      </Button>
    ),
  };

  const [toyData, setToyData] = useState(toy);

  useEffect(() => {
    setToyData(toy);
    return () => {};
  }, [toy]);

  const handleFieldClick = func => {
    onSendEvent(toy.name, func.function);
  };

  const handleFieldChange = (
    field,
    newValue,
    unit = null,
    max = null,
    min = null,
  ) => {
    field.value = newValue;
    if (unit) {
      field.unit = unit;
    }
    if (max != null) {
      field.max = max;
    }
    if (min != null) {
      field.min = min;
    }
    debouncedUpdate(JSON.parse(JSON.stringify(toyData)));
  };

  const debouncedUpdate = debounce(updatedToy => {
    update(updatedToy);
  }, 500);

  const update = updatedToy => {
    onUpdate(updatedToy);
  };

  const handleDelete = () => {
    onDelete(toyData.name);
  };

  return (
    <Card>
      {toyData ? (
        <>
          <CardHeader
            title={toyData.name}
            action={
              <IconButton aria-label="delete" onClick={handleDelete}>
                <DeleteIcon />
              </IconButton>
            }
          />
          <Divider />
          <CardContent>
            <Box display="flex" flexDirection="column">
              {toyData.functions.map((func, i1) =>
                func.fields.map((field, i2) => (
                  <Box marginBottom={1} marginTop={1} key={`${i1}.${i2}`}>
                    {fieldMap[field.ui](field, func)}
                  </Box>
                )),
              )}
            </Box>
          </CardContent>
        </>
      ) : (
        <></>
      )}
    </Card>
  );
};

export default ToyCard;
